module.exports = __webpack_public_path__ + "static/media/m11.dcb5b7cb.jpg";